import config from 'crm/config'

const storeApi = `${config.apiHost}/oem-profile`
const customerApi = `${config.apiHost}/oem-customer`
const authApi = `${config.apiHost}/oem-auth`

export default {
    // 门店配置信息
    config: {
        url: `${storeApi}/api/stores/config`,
        type: 'GET',
    },
    // 门店配置信息设置
    setConfig: {
        url: `${storeApi}/api/stores/config`,
        type: 'PUT',
    },
    // 门店分组树
    groups: {
        url: `${storeApi}/api/stores/groups/tree`,
        type: 'GET',
    },
    // 门店
    stores: {
        url: `${storeApi}/api/stores`,
        type: 'GET',
    },
    // 门店社群列表
    storeChatGroups: {
        url: `${customerApi}/api/oem_miniso/shop_group_chats`,
        type: 'GET',
    },
    // 更新门店数据
    sync: {
        url: `${storeApi}/api/stores/sync`,
        type: 'POST',
    },
    // 门店群活码更新
    syncGroupCode: {
        url: `${storeApi}/api/stores/sync_community_qrcode`,
        type: 'POST',
    },
    // 门店更新任务查询
    syncStatus: {
        url: `${storeApi}/api/stores/sync/status/{task_id}`,
        type: 'GET',
    },
    // 部门
    currentTree: {
        url: `${authApi}/api/departments/tree/current`,
        type: 'GET',
    },
    // 单个群活码更新
    updateStoreGroupCode: {
        url: `${storeApi}/api/stores/{id}/community_qrcode`,
        type: 'PUT',
    },
    // 引流码员工
    storeDrainageUsers: {
        url: `${storeApi}/api/stores/{id}/drainage_users`,
        type: 'GET',
    },
    // 下载导入模板
    downloadTemplate: {
        url: `${customerApi}/api/oem_miniso/group_chat_link.xlsx`,
        type: 'GET',
    },
    // 导入文件
    importGroupLink: {
        url: `${customerApi}/api/oem_miniso/group_chat_link/import`,
        type: 'POST',
    },

    updateFullUsers: {
        url: `${customerApi}/api/oem_miniso/full_users`,
        type: 'PUT',
    },

    downloadFullUsers: {
        url: `${customerApi}/api/oem_miniso/full_users.xlsx`,
        type: 'GET',
    },
}
